import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import ExpandableText from '../ExpandableText';

const LocationList = ({
  locations,
}) => {

  const getList = () => {
    return locations.map((l) => {
      return (
        <li>
          {l}
        </li>
      );
    });
  };

  return (
    <ExpandableText
      collapsedText="See more locations"
      expandedText="See fewer locations"
    >
      <ul>
        {getList()}
      </ul>
    </ExpandableText>
  );
};

LocationList.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.object),
};

LocationList.defaultProps = {
  locations: ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p"],
};

export default LocationList;
